<template>
  <div class="maintenance-box">
    <div class="panel">
      <d-table 
        :viewKey="'roleId'"
        :seekKey="seekKey"
        :theadText="theadText"
        :tbodyData="tbodyData" 
        :confirmDelete="confirmDelete" 
        :page="page"
        :selPage="selPage"
        :deleteDataKeys="deleteDataKeys"
        :btnGroup="btnGroup"
        @handleChangeSeekKey="handleChangeSeekKey"
        @handleChangeSeekVal="handleChangeSeekVal"
        @handleSeek="handleSeek"
        @toAdd="toAdd"
        @toEdit="toEdit"
        @toDelete="toDelete" 
        @hanldeDelete="hanldeDelete" 
        @hanldeChecked="hanldeChecked"
        @toConfirmDelete="toConfirmDelete"
        @selPage="selPageFn"
        @pagingFn="pagingFn"
        @refresh="refresh" />
    </div>
  </div>
</template>

<script>
import { URL_ROLELIST, URL_ROLE } from 'api/api.js'
import dTable from 'components/dataTable'
export default {
  mixins: [require("common/mixin/base.js").base({tableModelLan:"tableModel"})],
  data() {
    return {
      tbodyData: [],
      confirmDelete: false,
      deleteDataKeys: [],
      btnGroup: {
        refresh: 'refresh',
        add: 'addRole',
        delete: 'deleteRole',
        confirmDelete: 'confirmDelete',
      },
      seekKey: {
        active: this.$route.query.seekKey ? this.$route.query.seekKey : 'roleId',
        list: ['roleId', 'roleName'],
        seekVal: this.$route.query.seekVal ? this.$route.query.seekVal : '',
      },
      page: {
        active: this.$route.query.pageIndex ? parseInt(this.$route.query.pageIndex) : 1,
        pageLeng: 0,
        offset: 0,
      },
      selPage: {
        list: ['5','10','25','50'],
        active: localStorage.pageMaxIndex, 
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      }
    }
  },
  computed: {
    theadText() {
      return this.tableModelLan.roleThead
    },
  },
  components: {
    dTable,
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() { // 获取数据列表
      let args = '?pageNum='+(this.page.active-1)+'&pageSize='+this.selPage.limit+'&seekVal='+this.seekKey.seekVal+'&seekKey='+this.seekKey.active
      this.$http.get(URL_ROLELIST+args).then(res => {
        if(res.data.code === 200 && Array.isArray(res.data.data.list) && res.data.msg === 'OK') {
          let data = res.data.data
          this.page.pageLeng = data.count
          for(let item of data.list){
            let fnList = []
            for(let fn of item.functions){
              if(fn.readOnly) fnList.push(fn.name+'_readOnly') // (${this.tableModelLan.readOnly})
              else fnList.push(fn.name)
            }
            item.functions = fnList.join('; ')
            item.lastUpdate = this.$moment(item.lastUpdate).format("YYYY-MM-DD HH:mm:ss")
          }
          this.tbodyData = data.list.concat([])
        }
      }).catch(e => alert(e))
    },
    handleChangeSeekKey(item) { // 改变搜索的key
      this.seekKey.active = item
    },
    handleChangeSeekVal(seekVal){ // 改变搜索的value
      this.seekKey.seekVal = seekVal
    },
    handleSeek(){ // 处理搜索的方法
      this.getDataList()
    },
    toDelete() { // 去删除
      this.confirmDelete = true
    },
    toConfirmDelete() { // 去确认删除
      if(this.deleteDataKeys.length>0 && confirm(this.tableModelLan.confirmDeleteTips)){
        let pAll = []
        for(let deleteItem of this.deleteDataKeys) {
          pAll.push(this.$http.delete(URL_ROLE,{data: {roleId: deleteItem}}))
        }
        Promise.all(pAll).then( (res)=> {
          res.map( v =>{
            if(v.data.code === 400) return alert(v.data.msg)
            this.page.active = 1
            this.page.offset = 0
            this.getDataList()
            this.deleteDataKeys = []
            this.confirmDelete = false
          })
        }).catch(e => alert(e))
      }else if (this.deleteDataKeys.length === 0 ) this.confirmDelete = false 
    },
    hanldeDelete(index) { // 处理点击删除图标按钮
      this.deleteDataKeys.push(this.tbodyData[index].roleId)
    },
    hanldeChecked(index) { // 处理点击打钩图标按钮
      let code = this.deleteDataKeys.indexOf(this.tbodyData[index].roleId)
      this.deleteDataKeys.splice(code,1)
    },
    toEdit(roleId){ // 去到修改页面
      let url = '/roleEdit?roleId='+roleId+'&pageIndex='+this.page.active+'&seekKey='+this.seekKey.active+'&seekVal='+ this.seekKey.seekVal
      this.$router.push(url)
    },
    toAdd(){ // 去到添加角色页面
      let url = '/addRole?pageIndex='+this.page.active+'&seekKey='+this.seekKey.active+'&seekVal='+ this.seekKey.seekVal
      this.$router.push(url)
    },
    selPageFn(index, item) { // 选择一页显示的条目数量
      this.SAVEPAGEMAXINDEX(index)
      this.selPage.active = index
      this.selPage.limit = this.selPage.list[this.selPage.active]
      this.page.offset = 0
      this.page.active = 1
      this.getDataList()
    },
    pagingFn(index){ // 翻页回调函数
      this.page.active = index
      this.getDataList()
    },
    refresh() { // 重新获取全部数据
      this.page.active = 1
      this.page.offset = 0
      this.seekKey.seekVal = ''
      this.getDataList()
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/views/roleMaintenance/roleMaintenance.vue